export const RISK_BAND_CEILINGS_PCT = {
  low: 5,
  midLow: 8,
  midHigh: 11,
} as const;

export function riskBandKey(percent: number): string {
  const rounded = Math.round(percent * 1e9) / 1e9;
  if (rounded <= RISK_BAND_CEILINGS_PCT.low) return "rebalance.riskBands.low";
  if (rounded <= RISK_BAND_CEILINGS_PCT.midLow) return "rebalance.riskBands.midLow";
  if (rounded <= RISK_BAND_CEILINGS_PCT.midHigh) return "rebalance.riskBands.midHigh";
  return "rebalance.riskBands.high";
}
